import {ChevronIcon, Trail} from '@yandex-delivery/blocks'
import React from 'react'

import type {NavWidgetProps as Props} from '../types'

export function NavWidget(_: Props): React.ReactElement {
  return (
    <Trail>
      <ChevronIcon />
    </Trail>
  )
}
